import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Dropdown, Icon } from 'rsuite';
import { outreachBasePath, outreachDashboardPath } from '../../../routes/Paths';
import { getUserPermissionsAsMap } from '../../../redux/selectors/permission';
import * as PERMISSIONS from '../../../constants/permissions/outreach';
import {
  viewAccess,
  modifyAccess,
  hasViewAccess
} from '../../../helpers/permission';
import MainLayout from '../../../containers/MainLayout';
import MainContent from '../../MainContent';
import SidebarNav from '../../SidebarNav';
import AccessControl from '../../AccessControl';
import NavLink from '../../NavLink';

const NAV_KEYS = {
  DASHBOARD: 1,
  OUTREACHES: 2
};

const PageLayout = ({ children }) => {
  const permissions = useSelector(getUserPermissionsAsMap);
  return (
    <MainLayout>
      <MainContent>
        <SidebarNav>
          <AccessControl allowWhenAny={[viewAccess(PERMISSIONS.DASHBOARD)]}>
            <NavLink
              to={outreachBasePath}
              eventKey={NAV_KEYS.DASHBOARD}
              icon={<Icon icon="dashboard" />}
            >
              Dashboard
            </NavLink>
          </AccessControl>

          {hasViewAccess(PERMISSIONS.OUTREACH, permissions) && (
            <Dropdown
              title="Outreaches"
              icon={<Icon icon="list-ul" />}
              eventKey={NAV_KEYS.OUTREACHES}
              placement="rightStart"
            >
              <AccessControl
                allowWhenAny={[modifyAccess(PERMISSIONS.OUTREACH)]}
              >
                <NavLink
                  to={outreachDashboardPath}
                  eventKey={`${NAV_KEYS.OUTREACHES}_1`}
                >
                  <Icon icon="file" /> &nbsp; New
                </NavLink>
              </AccessControl>
              <NavLink
                to={outreachDashboardPath}
                eventKey={`${NAV_KEYS.OUTREACHES}_2`}
              >
                <Icon icon="list-alt" /> &nbsp; List
              </NavLink>
            </Dropdown>
          )}
        </SidebarNav>
        <Container>{children}</Container>
      </MainContent>
    </MainLayout>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageLayout;
